import React from 'react';
import '../../styles/pages/_home.scss';
import Hero from './Hero';
import ServicesSlider from './ServicesSlider';
import NewsTabs from '../../components/NewsTabs/NewsTabs';
import ServicesGrid from './ServicesGrid';
import VideoGallery from '../../components/VideoGallery/VideoGallery';
import Projects from "../../components/Projects/Projects";
import NoticeAndTenderStrip from "../../components/Announcements/NoticeAndTenderStrip";

function Home() {
  return (
    <div className="home lg-mt-5">
        <Hero />
        <ServicesSlider />
        <Projects />
        <ServicesGrid />
        <NoticeAndTenderStrip />
        
      
      
    </div>
  );
}

export default Home;
